import { Logger } from './Logger';

export enum RoundIntegrityWatcherPhases {
  Game = 0b1,
  Timer = 0b10,
  BetsOpen = 0b100,
  BetsClosed = 0b1000,
  StartDealing = 0b10000,
  Win = 0b100000,
  WinnersPaid = 0b1000000,
}

// sum of all phases
const fullRound = 0b1111111;

// sum of all phases except win message
const roundWithoutBets = 0b1011111;

class RoundIntegrityWatcherBase {
  private roundState: number = 0b0;
  private hadBets = false;
  private initial: boolean | null = null;

  public setHadBets(): void {
    if (this.roundState !== 0) {
      this.hadBets = true;
    }
  }

  public resetRoundState(): void {
    this.roundState = 0;
    this.hadBets = false;
  }

  public setPhase(phase: RoundIntegrityWatcherPhases): void {
    if (this.initial === null && phase === RoundIntegrityWatcherPhases.Game) {
      this.initial = true;
    }
    if (phase === RoundIntegrityWatcherPhases.Game && this.roundState !== 0) {
      this.logRoundState();
      this.initial = false;
    }
    this.roundState |= phase;
  }

  logRoundState(): void {
    const isComplete = this.hadBets ? this.roundState === fullRound : this.roundState === roundWithoutBets;

    Logger.logEvent('roundIntegrity', {
      additional: `${isComplete ? 'complete' : 'incomplete'}${this.initial ? '-initial' : ''}`,
      bandwidth: this.roundState,
    });

    this.resetRoundState();
  }
}

export const RoundIntegrityWatcher = new RoundIntegrityWatcherBase();
